/* Jalecos Mania — busca inteligente do header.
   Espelha o renderSearchResults do site local, mas usando a Predictive Search
   nativa do Shopify (/search/suggest + section_id=jm-busca-resultados). */
(function () {
  var SECTION_ID = 'jm-busca-resultados';
  document.querySelectorAll('[data-jm-search]').forEach(setup);

  function setup(form) {
    var input = form.querySelector('input[type="search"]');
    var results = form.querySelector('[data-jm-search-results]');
    var clearBtn = form.querySelector('[data-jm-search-clear]');
    if (!input || !results) return;

    var suggestionsHTML = results.innerHTML; // estado inicial "Mais buscados"
    var timer = null;

    function open() { form.classList.add('is-open'); }
    function close() { form.classList.remove('is-open'); }

    function showSuggestions() {
      results.innerHTML = suggestionsHTML;
      if (clearBtn) clearBtn.hidden = true;
    }

    function run(q) {
      q = (q || '').trim();
      if (clearBtn) clearBtn.hidden = !q;
      if (!q) { showSuggestions(); return; }

      var url = '/search/suggest?q=' + encodeURIComponent(q) +
        '&section_id=' + SECTION_ID +
        '&resources[type]=product&resources[limit]=6';

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          if (q !== input.value.trim()) return; // descarta resposta obsoleta
          results.innerHTML = html;
        })
        .catch(function () { /* silencioso */ });
    }

    input.addEventListener('focus', open);
    input.addEventListener('input', function () {
      open();
      clearTimeout(timer);
      timer = setTimeout(function () { run(input.value); }, 200);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        run(''); // restaura "Mais buscados" para a próxima abertura
        close(); // mas fecha o dropdown agora
        input.blur();
      });
    }

    // clique num chip de "Mais buscados"
    results.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-jm-suggest]');
      if (!chip) return;
      input.value = chip.textContent.trim();
      input.focus();
      run(input.value);
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); }
    });
  }
})();
